import { Query } from '../../../../hooks/queries'
import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import {
  getServerlessAccounts,
  GetServerlessAccountsArgs
} from './requests/get-serverless-accounts'
import { ServerlessApiAccount } from './shared'

export interface UseServerlessAccountsQueryProps {
  organizationUuid: string
}

export interface ServerlessAccountsQueryResponse {
  accounts: ServerlessApiAccount[] | undefined
  error: Error | null
  isError: boolean
  isLoading: boolean
}

export type UseServerlessAccountsQuery = (
  props: UseServerlessAccountsQueryProps
) => ServerlessAccountsQueryResponse

export const useServerlessAccountsQuery: UseServerlessAccountsQuery = ({
  organizationUuid
}) => {
  const {
    data: accounts,
    error,
    isError,
    isLoading
  } = useContrastQuery<GetServerlessAccountsArgs, ServerlessApiAccount[]>(
    [Query.INTEGRATIONS_SERVERLESS_ACCOUNTS, organizationUuid],
    getServerlessAccounts,
    { organizationUuid }
  )

  return {
    accounts,
    error,
    isError,
    isLoading
  }
}
